// extracted by mini-css-extract-plugin
export var attachButton = "_co-8";
export var sendButton = "_co-2";
export var sendDisabled = "_co-4";
export var sendEnabled = "_co-3";
export var sendIcon = "_co-6";
export var sendIconDisabled = "_co-7";
export var sendStreaming = "_co-5";
export var textarea = "_co-1";
export var wrapper = "_co-0";